import { Box, Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps, styled, tooltipClasses, useMediaQuery, useTheme } from "@mui/material"
import { TooltipProvider } from "./TooltipProvider";

export type TooltipProps = Omit<MuiTooltipProps, "title"> & {
    bodyBuilder: (mobileVersion: boolean) => React.ReactNode;
    mobileHeader: string;
}

export const Tooltip = (props: TooltipProps) => {
    const theme = useTheme();

    const onlyMediumScreens = useMediaQuery(theme.breakpoints.down('md'));

    if (onlyMediumScreens) return MobileTooltip(props);

    const { children, bodyBuilder, mobileHeader, ...restProps } = props;

    return (
        <MuiTooltipStyled title={props.bodyBuilder(false)} {...restProps}>
            {children}
        </MuiTooltipStyled>
    );
}

const MuiTooltipStyled = styled(({ className, ...props }: MuiTooltipProps) => (
    <MuiTooltip {...props} classes={{ popper: className }} />
))({
    [`& .${tooltipClasses.tooltip}`]: {
        maxHeight: 300,
        maxWidth: window.innerWidth / 3,
        overflowY: "auto",
    },
});

export const MobileTooltip = (props: TooltipProps) => {
    const { setTooltip } = TooltipProvider.useTooltip();

    return (
        <>
            <Box onClick={() => {
                setTooltip({ body: props.bodyBuilder(true), mobileHeader: props.mobileHeader });
            }}>
                {props.children}
            </Box>
        </>
    );
}